// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn--rP4Q6","btn-icon":"btn-icon--BfOpG","btnIcon":"btn-icon--BfOpG","btn-content":"btn-content--at4dn","btnContent":"btn-content--at4dn","editable":"editable--fleOY"};